import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-primary/5 px-4" data-testid="payment-cancel-page">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 md:p-12 border border-slate-200 text-center">
          <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-orange-600" data-testid="cancel-icon" aria-hidden="true" />
          </div>

          <h1 className="text-3xl font-bold text-secondary mb-4">{t('checkout.cancel.title')}</h1>
          <p className="text-foreground/70 text-lg mb-8">{t('checkout.cancel.subtitle')}</p>

          <div className="bg-orange-50 rounded-lg p-6 mb-8 text-left">
            <div className="flex items-start gap-3">
              <HelpCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-0.5" aria-hidden="true" />
              <div>
                <h3 className="font-semibold text-secondary mb-2">{t('checkout.cancel.whatHappened')}</h3>
                <ul className="list-disc list-inside text-foreground/70 mt-2 space-y-1">
                  <li>{t('checkout.cancel.reason1')}</li>
                  <li>{t('checkout.cancel.reason2')}</li>
                  <li>{t('checkout.cancel.reason3')}</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-primary/5 rounded-lg p-6 mb-8">
            <h3 className="font-semibold text-secondary mb-2">{t('checkout.cancel.assist')}</h3>
            <p className="text-foreground/70 mb-4">{t('checkout.cancel.assistText')}</p>
            <div className="flex flex-col sm:flex-row gap-2 justify-center">
              <a href="mailto:support@treatx.health" className="text-primary hover:underline">support@treatx.health</a>
              <span className="hidden sm:inline text-foreground/40">|</span>
              <a href="mailto:info@treatx.health" className="text-primary hover:underline">info@treatx.health</a>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="flex-1 h-12 rounded-full"
              data-testid="go-back-button"
            >
              <ArrowLeft className="w-5 h-5 mr-2" aria-hidden="true" />
              {t('checkout.cancel.goBack')}
            </Button>
            <Button
              onClick={() => navigate('/treatments')}
              className="flex-1 h-12 bg-primary hover:bg-primary/90 rounded-full"
              data-testid="browse-treatments-button"
            >
              {t('checkout.cancel.browseTreatments')}
            </Button>
          </div>

          <p className="text-sm text-foreground/60 mt-8">{t('checkout.cancel.safe')}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;